import { render, staticRenderFns } from "./DisableToolbarLabSetting.vue?vue&type=template&id=7b3d7364&scoped=true&"
import script from "./DisableToolbarLabSetting.vue?vue&type=script&lang=js&"
export * from "./DisableToolbarLabSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3d7364",
  null
  
)

export default component.exports